var $2b6e161c9edcf319$exports = {};
/**
 * Ensure requested pattern is valid:
 * - pattern was requested
 * - pattern is exactly 5 characters
 * - pattern does not contain numbers
 */ const $2b6e161c9edcf319$var$patternIsValid = function(pattern) {
    if (pattern.length !== 5) {
        console.log('Invalid pattern requested: pattern should be 5 characters');
        return 'Invalid pattern requested: pattern should be 5 characters';
    }
    if (pattern.search(/[^a-z*]/gi) !== -1) {
        console.log('Invalid pattern requested: pattern should not contain numbers or special characters other than *');
        return 'Invalid pattern requested: pattern should not contain numbers or special characters other than *';
    }
    return true;
};
/**
 * Convert pattern to regex pattern
 */ const $2b6e161c9edcf319$var$patternToRegex = function(pattern) {
    let expression = '';
    for(let i = 0; i < pattern.length; i++)if (pattern[i].search(/[a-z]/gi) > -1) expression += pattern[i];
    else expression += '[a-z]';
    return expression;
};
/**
 * Find matching solutions
 */ const $2b6e161c9edcf319$var$findMatches = function(pattern, solutions, omissions) {
    const isValid = $2b6e161c9edcf319$var$patternIsValid(pattern);
    if (isValid === true) {
        const regexPattern = $2b6e161c9edcf319$var$patternToRegex(pattern);
        const expression = new RegExp(regexPattern, 'gim');
        const possibleSolutions = solutions.match(expression);
        // omissions are letters known not to match that
        // are used to filter out possible solutions
        if (typeof omissions !== 'undefined' && omissions.length > 0) {
            const negation = new RegExp(`[${omissions}]`, 'i');
            const matchedSolutions = possibleSolutions.filter((nextPossible)=>negation.test(nextPossible) === false);
            return matchedSolutions;
        } else return possibleSolutions;
    } else return [
        isValid
    ];
};
$2b6e161c9edcf319$exports = {
    findMatches: $2b6e161c9edcf319$var$findMatches,
    patternIsValid: $2b6e161c9edcf319$var$patternIsValid,
    patternToRegex: $2b6e161c9edcf319$var$patternToRegex
};


const $8a3974c14be04857$var$elem = React.createElement;
class $8a3974c14be04857$var$HelperForm extends React.Component {
    constructor(props){
        super(props);
        this.handleFind = this.handleFind.bind(this);
        this.handleUpdateSearchPattern = this.handleUpdateSearchPattern.bind(this);
        this.state = {
            searchPattern: '',
            matchedSolutions: []
        };
    }
    render() {
        return $8a3974c14be04857$var$elem('form', {
            autocomplete: 'off'
        }, [
            $8a3974c14be04857$var$elem('label', {
                for: '#search-input'
            }, 'Search'),
            $8a3974c14be04857$var$elem('input', {
                ariaLabel: 'Search',
                autoFocus: true,
                id: 'search-input',
                key: 'input0',
                label: 'Search for:',
                maxLength: 5,
                onChange: this.handleUpdateSearchPattern,
                placeholder: 'search',
                type: 'text'
            }),
            $8a3974c14be04857$var$elem('button', {
                ariaLabel: 'Submit',
                key: 'button0',
                onClick: this.handleFind,
                title: 'Submit'
            }, $8a3974c14be04857$var$elem('i', {
                className: 'gg-search'
            })),
            $8a3974c14be04857$var$elem($8a3974c14be04857$var$HelperOutput, {
                key: 'output0',
                matchedSolutions: this.state.matchedSolutions
            })
        ]);
    }
    handleFind(event) {
        const solutionsUri = 'https://gist.githubusercontent.com/paddyredbeard/95cec9ed4a7a15b4c7209ba8502438de/raw/e73c6698ada392ec955f8d3b985bb9de995fd6ad/wordle-solutions.txt';
        fetch(solutionsUri, {}).then((response)=>response.text()).then((text)=>{
            const matches = findMatches(this.state.searchPattern, text);
            this.setState({
                matchedSolutions: matches
            });
        });
        event.preventDefault();
    }
    handleUpdateSearchPattern(event) {
        this.setState({
            searchPattern: event.target.value
        });
    }
}
class $8a3974c14be04857$var$HelperOutput extends React.Component {
    render() {
        let solutions;
        if (!this.props.matchedSolutions || this.props.matchedSolutions.length === 0) solutions = $8a3974c14be04857$var$elem('code', {
            className: 'no-solution'
        }, 'No Matches');
        else solutions = this.props.matchedSolutions.map((next, i)=>{
            return $8a3974c14be04857$var$elem('code', {
                className: 'helper-solution',
                key: `solution${i}`
            }, next);
        });
        return $8a3974c14be04857$var$elem('div', {
            className: 'helper-output'
        }, solutions);
    }
}
const $8a3974c14be04857$var$domContainer = document.querySelector('#helperContainer');
const $8a3974c14be04857$var$root = ReactDOM.createRoot($8a3974c14be04857$var$domContainer);
$8a3974c14be04857$var$root.render($8a3974c14be04857$var$elem($8a3974c14be04857$var$HelperForm));


window.findMatches = (0, $2b6e161c9edcf319$exports.findMatches);


//# sourceMappingURL=public.dfb7e646.js.map
